/**
 * Compact on-brand stat tile (label + value + optional note). Shared by the
 * admin and client Clients summary rows. Purely presentational.
 */
export function Stat({
  label,
  value,
  note,
}: {
  label: string;
  value: string;
  note?: string;
}) {
  return (
    <div className="rounded-[var(--kkp-radius)] border border-[color:var(--kkp-border)] bg-[color:var(--kkp-surface)] px-3 py-2">
      <div className="text-[11px] font-semibold text-[color:var(--kkp-text-muted)]">
        {label}
      </div>
      <div className="mt-0.5 truncate text-sm font-bold text-white">
        {value}
      </div>
      {note ? (
        <div className="mt-0.5 text-[11px] text-[color:rgba(255,255,255,0.65)]">
          {note}
        </div>
      ) : null}
    </div>
  );
}
